
import { ObjectFactory } from '@/config/objectFactory';
/**
 * @author <Aniket.P>
 * @description Date utils
 * @copyright Supra International, inc
 */
import moment from 'moment-timezone';
export class DateUtils {

    public static readonly FORMAT_DATETIME_AM_PM = 'MM/DD/YYYY hh:mm a z';
    public static readonly DEFAULT_TIMEZONE = 'America/Detroit';

    public static getCurrentTimeInMillis(): number {
        const timeInMillis = new Date().getTime();
        return timeInMillis;
    }

    public static getCurrentUTCTimeInMillis(): number {
        const timeInMillis = Date.parse(new Date().toUTCString());
        return timeInMillis;
    }

    public static formatDate(date: any, format?: string, timeZone?: string): string {
        if (!timeZone) {
            timeZone = ObjectFactory.getCacheService().getSessionInfo().timezone;
        }

        if (!format) {
            format = DateUtils.FORMAT_DATETIME_AM_PM;
        }
        if (timeZone && timeZone === 'America/Dawson') {
            timeZone = 'America/Los_Angeles';
        } else if (timeZone && timeZone === 'America/Detroit') {
            timeZone = 'America/New_York';
        } else if (timeZone && timeZone === 'America/Boise') {
            timeZone = 'America/Denver';
        }
        const momentObj = moment.tz(date, timeZone as any);
        const formattedTime = momentObj.format(format);
        return formattedTime;
    }

    public static getDurationText(totalMinutes: number) {
        let durationText = `${totalMinutes} Minutes`;
        if (totalMinutes >= 60) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            let hourText = 'Hours';
            let minutesText = 'Minutes';
            if (hours === 1) {
                hourText = 'Hour';
            }
            if (minutes === 1) {
                minutesText = 'Minute';
            }
            durationText = `${hours} ${hourText}`;
            if (minutes > 0) {
                durationText += ` and ${minutes} ${minutesText}`;
            }
        }
        return durationText;
    }

    public static convertMinutesToMillis(minutes: number): number {
        return minutes ? Math.floor(minutes * 60 * 1000) : 0;
    }

    public static convertMillisToMinutes(millis: number): number {
        return millis ? Math.floor(millis / 60000) : 0;
    }
    public static convertToUTCInMillis(dateTime: any, timeZone?: string): number {
        timeZone = timeZone ? timeZone : this.DEFAULT_TIMEZONE;
        if (timeZone && timeZone === 'America/Dawson') {
            timeZone = 'America/Los_Angeles';
        } else if (timeZone && timeZone === 'America/Detroit') {
            timeZone = 'America/New_York';
        } else if (timeZone && timeZone === 'America/Boise') {
            timeZone = 'America/Denver';
        }
        const datetimeWithTimezone = moment.tz(dateTime, timeZone).format('YYYY-MM-DD HH:mm:ss ZZ');
        const timeInMillis = Date.parse(datetimeWithTimezone);
        return new Date(timeInMillis).getTime();
    }
    public static convertDaysToMillis(days: number): number {
        return days ? Math.floor(days * 24 * 60 * 60 * 1000) : 0;
    }

    public static convertMillisToHours(millis: number): number {
        const minutes = this.convertMillisToMinutes(millis);
        return minutes ? Math.floor(minutes / 60) : 0;
    }

}
